const button = document.querySelector("#trigger")
button.addEventListener('click', e => {
    document.querySelector("#gform_submit_button_1").click();
})